module.exports = __webpack_public_path__ + "static/media/exactly-icon.d7857396.svg";